import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { SliceStatus } from '../../interfaces/Redux';
import { Profile } from '../../interfaces/User'
import { validateProfilePicture } from '../../services/assetService';
import { get } from '../../services/http'
import { defaultProfile } from '../intialState/profile';
import { logOut } from '../../services/authservice';

//translations
import localisation from "../../services/localisation";
import IL from "../../interfaces/localisation";




export interface ProfileState {
  profile: Profile
  status: SliceStatus
  error?: string | undefined
}

const initialState: ProfileState = {
  profile: defaultProfile,
  status: SliceStatus.initial,
  error: ''
}   

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    logout: () => {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProfile.pending, (state, action) => {
        state.status = SliceStatus.loading
        state.error = undefined
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded
          // Add any fetched posts to the array
          state.profile = {
            ...action.payload,
            "profilePictureUrl": validateProfilePicture(action.payload.profilePictureUrl)
          }
          state.error = undefined
        }
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = SliceStatus.failed
        state.error = action.error.message
      })
  }
})

export const fetchProfile = createAsyncThunk('profile/fetchProfile', async () => {

  return get(`api/user/me/profile`).then((response) => {
      return response.data
  }).catch((error) => {
      if (error.response.status === 500){
        logOut();
      }
      throw new Error(error.message);
  }); 

});

// Action creators are generated for each case reducer function
export const { logout } =  profileSlice.actions

export default profileSlice.reducer



